import React from 'react';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import ClickableSquare from '../../components/HomePage/ClickableSquare/ClickableSquare';
import ClearButton from '../../components/HomePage/ClearButton/ClearButton';
import styles from './Home.module.css';
import Footer from '../../components/common/Footer/Footer';


const Home = () => {
  const clearAction = () => {
    const email = 'support@culturehint.com';
    const subject = 'New support message';
    const body = 'Scrivere qui la richiesta di supporto. Il team di Culture Hint risponderà a breve.';
    const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoLink;
  };

  return (
    
    <div className={styles.homePage}>
    <div> <p className={styles.p}>Ti informiamo che questo sito web utilizza i cookie per migliorare la tua esperienza di navigazione. Se continui a navigare, accetti l'utilizzo dei cookie.</p></div>

      <div className={styles.squaresContainer}>
        <ClickableSquare text="Opportunità" icon={<ImageOutlinedIcon sx={{ fontSize: 50 }} />} link="/projects" />
        <ClickableSquare text="Arrivi" icon={<AssessmentOutlinedIcon sx={{ fontSize: 50 }}/>} link="/arrivi" />
        <ClickableSquare text="Report" icon={<DescriptionOutlinedIcon sx={{ fontSize: 50 }}/>} link="/report" />
        <ClickableSquare text="Piano Turistico" icon={<SettingsOutlinedIcon sx={{ fontSize: 50 }} />} link="/pianoturistico" />
      </div>
      <div className={styles.buttonCover}>
        <ClearButton text="ASSISTENZA" onClick={clearAction} />
      </div>

      <Footer></Footer>
    </div>
    
  );
};

export default Home;